import { usePaginatedRequest } from '@Hooks/usePaginatedRequest';
import { API } from '@Services';
import { Selection } from '@Types';
import { SelectionStatusEnum, FundSelectionsApiResponse } from '@Types/Selection';
import { useCallback } from 'react';

export const useGetFundSelectionsPaginated = () => {
  const [fetch, response] = usePaginatedRequest<Selection, FundSelectionsApiResponse>({
    perPage: 10,
  });

  const getFundSelectionsPaginated = useCallback(
    (fundId: number, statuses: SelectionStatusEnum[]) => {
      fetch(API.paths.fund_selections(fundId), {
        statusIn: statuses.join(','),
      });
    },
    [fetch],
  );

  return [getFundSelectionsPaginated, response] as const;
};
